import { EventEmitter, Injectable, inject } from '@angular/core';
import { environment } from '@env';
import * as signalR from '@microsoft/signalr';
import { NotificationService } from 'src/app/core/services/notification.service';
import { QueryModelUpdated } from 'src/app/models/query-model-updated.model';

@Injectable({
   providedIn: 'root',
})
export class ConnectionResolver {
   private notificationService = inject(NotificationService);
   private readonly platformHubUrl = environment.platformHubUrl;

   failedHubConnectionAttempts = 0;
   private connection: signalR.HubConnection = null!;
   private connectionId: string;
   queryModelUpdated: EventEmitter<QueryModelUpdated> = new EventEmitter<QueryModelUpdated>();

   resolve() {
      if (!this.connection || this.connection.state === signalR.HubConnectionState.Disconnected) {
         this.configureSignalR();

         this.connection
            .start()
            .then(() => {
               this.failedHubConnectionAttempts = 0;
               console.log('Platform SignalR connection established.');
            })
            .catch(() => {
               this.failedHubConnectionAttempts++;

               console.log('Could not connect to Platform SignalR.');

               if (this.failedHubConnectionAttempts < 5) {
                  setTimeout(() => {
                     this.resolve();
                  }, 5000);
               } else {
                  this.notificationService.showDialogError(
                     'SignalRConnectionErrorMsg',
                     'SignalRConnectionErrorTitle'
                  );
                  console.log('SignalRConnectionErrorTitle');
                  this.failedHubConnectionAttempts = 0;
               }
            });
      }
   }

   getConnectionId(): string {
      return this.connectionId;
   }

   private configureSignalR() {
      this.connection = new signalR.HubConnectionBuilder().withUrl(this.platformHubUrl).build();
      this.connection.serverTimeoutInMilliseconds = 60000;
      this.connection.keepAliveIntervalInMilliseconds = 30000;

      this.connection.on('GetConnected', (connectionId: string) => {
         this.connectionId = connectionId;
      });

      this.connection.on('QueryModelUpdated', (message: string | null) => {
         if (!message) {
            return;
         }

         const splittedMessage = message.split(';');
         this.queryModelUpdated.emit(
            new QueryModelUpdated(
               splittedMessage.length > 1 ? splittedMessage[1] : '',
               splittedMessage[0]
            )
         );
      });

      this.connection.on('ErrorOccurred', (errorMessage: any) => {
         console.log(errorMessage);
      });

      this.connection.onclose((event: any) => {
         console.log('Platform SignalR connection closed.');
         console.log('Reconnecting...');
         this.connectionId = null!;
         this.resolve();
      });

      console.log('Platform SignalR connection configured.');
   }
}
